<label class="checkbox-container">
  <input
    type="checkbox"
    class="checkbox-input"
    [checked]="checked()"
    [disabled]="disabled()"
    [attr.aria-label]="ariaLabel()"
    (change)="onCheckboxChange($event)"
  />
  <span class="checkbox-custom"></span>
</label>
